<template>
    <div class="items-center p-6">
        <div class="flex items-center pb-3">
            <div class="chart-inner-headline pl-4">{{label}}</div>
        </div>
        <div class="px-4">
            <table class="w-full">
                <tr class="pb-5">
                    <td>&nbsp;</td>
                    <td align="center"><img :src="icons.hearts"/></td>
                    <td align="center"><img :src="icons.hello"/></td>
                    <td align="center"><img :src="icons.fingersCrossed"/></td>
                    <td align="center"><img :src="icons.bang"/></td>
                </tr>
                <tr class="border border-r-0 border-l-0 border-b-0 py-4">
                    <td class="text-xs py-3">Last 20 sec.</td>
                    <td align="center">{{ parseInt(this.pick('hearts')?.last_20_seconds ?? 0) | toNumber(0,0) }}</td>
                    <td align="center">{{ parseFloat(this.pick('hello')?.last_20_seconds ?? 0) | toNumber(0,0) }}</td>
                    <td align="center">{{ parseFloat(this.pick('fingers-crossed')?.last_20_seconds ?? 0) | toNumber(0,0) }}</td>
                    <td align="center">{{ parseFloat(this.pick('bang')?.last_20_seconds ?? 0) | toNumber(0,0) }}</td>
                </tr>
                <tr class="border border-r-0 border-l-0 border-b-0 py-4">
                    <td class="text-xs py-3">Last 20 sec. / min.</td>
                    <td align="center">{{ parseInt(this.pick('hearts')?.last_20_seconds_min ?? 0) | toNumber(2,2) }}</td>
                    <td align="center">{{ parseFloat(this.pick('hello')?.last_20_seconds_min ?? 0) | toNumber(2,2) }}</td>
                    <td align="center">{{ parseFloat(this.pick('fingers-crossed')?.last_20_seconds_min ?? 0) | toNumber(2,2) }}</td>
                    <td align="center">{{ parseFloat(this.pick('bang')?.last_20_seconds_min ?? 0) | toNumber(2,2) }}</td>
                </tr>
                <tr class="border border-r-0 border-l-0 border-b-0 py-4">
                    <td class="text-xs py-3">Last 2 min. / min.</td>
                    <td align="center">{{ parseInt(this.pick('hearts')?.last_2_minutes_min ?? 0) | toNumber(2,2) }}</td>
                    <td align="center">{{ parseFloat(this.pick('hello')?.last_2_minutes_min ?? 0) | toNumber(2,2) }}</td>
                    <td align="center">{{ parseFloat(this.pick('fingers-crossed')?.last_2_minutes_min ?? 0) | toNumber(2,2) }}</td>
                    <td align="center">{{ parseFloat(this.pick('bang')?.last_2_minutes_min ?? 0) | toNumber(2,2) }}</td>
                </tr>
                <tr class="border border-r-0 border-l-0 border-b-0 py-4">
                    <td class="text-xs py-3">Last 60 min. / min.</td>
                    <td align="center">{{ parseInt(this.pick('hearts')?.last_60_min_min ?? 0) | toNumber(2,2) }}</td>
                    <td align="center">{{ parseFloat(this.pick('hello')?.last_60_min_min ?? 0) | toNumber(2,2) }}</td>
                    <td align="center">{{ parseFloat(this.pick('fingers-crossed')?.last_60_min_min ?? 0) | toNumber(2,2) }}</td>
                    <td align="center">{{ parseFloat(this.pick('bang')?.last_60_min_min ?? 0) | toNumber(2,2) }}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>

export default {
    components: {},
    props: {
        label: String,
        stats: {
            type: Array,
            default: []
        }
    },
    computed: {
        icons() {
            return {
                hearts: require('../../../img/emoji/hearts.png'),
                bang: require('../../../img/emoji/bang.png'),
                fingersCrossed: require('../../../img/emoji/fingers-crossed.png'),
                hello: require('../../../img/emoji/hello.png'),
            }
        }
    },
    methods: {
        pick(type) {
            return this.stats.find((stat) => stat.type === type);
        }
    }
}
</script>
